module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/bg_intro02-2462b17ffc13dbf08d092f7ee9d95257.jpg";